const CF_EOP_KEY = 'cf.total_cash_eop'
const BS_TOTAL_CASH_KEY = 'bs.total_cash_and_equivalents'

export function roundToCents(value: number): number {
  return Math.round(value * 100) / 100
}

export function cashTieBalanced(eop: number | null, bsCash: number | null): boolean | null {
  if (
    eop == null ||
    bsCash == null ||
    !Number.isFinite(eop) ||
    !Number.isFinite(bsCash)
  ) {
    return null
  }
  return roundToCents(eop) === roundToCents(bsCash)
}

type CashTieHistory = {
  nHistory: number
  values: Record<string, Record<string, Array<number | string | null>>>
}

type CashTieEvaluated = {
  values: Record<string, Record<string, Record<number, number | string | null>>>
}

export function cashTieValues(
  evaluated: CashTieEvaluated | null,
  history: CashTieHistory | null,
  view: string,
  t: number,
): { eop: number | null; bsCash: number | null } {
  const readNumeric = (key: string): number | null => {
    let raw: number | string | null | undefined
    if (t <= 0 && history) {
      const idx = history.nHistory - 1 + t
      raw = history.values[view]?.[key]?.[idx]
    } else {
      raw = evaluated?.values[view]?.[key]?.[t]
    }
    return typeof raw === 'number' && Number.isFinite(raw) ? raw : null
  }
  return {
    eop: readNumeric(CF_EOP_KEY),
    bsCash: readNumeric(BS_TOTAL_CASH_KEY),
  }
}
